import React from "react";
import { Page, Card, FormLayout, TextField, Text } from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";
import { useTranslation } from "react-i18next";

export default function SEOTemplateForm({
  SEOTemplate,
  selectedLocale,
  defaultLocale,
  getCurrentLocaleValue,
  getPlaceholderText,
  handleUpdate,
  discardChanges,
  getLocaleDisplayName, // Accept function from parent
}) {
  const { t } = useTranslation();
  
  function errorsFor(field) {
    const fieldErrors = SEOTemplate.errors?.[field];
    if (!fieldErrors) return null;
    return fieldErrors.join(" ");
  }

  // getLocaleDisplayName is now passed from parent component

  const isDefaultLocale = selectedLocale === defaultLocale;

  return (
    <Page>
      <TitleBar
        title={t("seoTemplates.template.title", { 
          templateName: SEOTemplate.title, 
          locale: getLocaleDisplayName(selectedLocale) 
        })}
        breadcrumbs={[{ content: t("seoTemplates.breadcrumbs.seoTemplates") }]}
      />
      <Card>
        <Card.Section
          title={t("seoTemplates.form.pageContent")}
          actions={[
            {
              content: t("seoTemplates.template.discardChanges"),
              disabled: !SEOTemplate.unsaved,
              destructive: true,
              onAction: discardChanges,
            },
          ]}
        >
          {!isDefaultLocale && (
            <div style={{ marginBottom: '1rem' }}>
              <Text variant="bodyMd" color="subdued">
                {t("seoTemplates.form.editingLocaleHelp", {
                  locale: getLocaleDisplayName(selectedLocale),
                  defaultLocale: getLocaleDisplayName(defaultLocale)
                })}
              </Text>
            </div>
          )}
          
          <FormLayout>
            <TextField
              label={t("seoTemplates.form.title")}
              value={getCurrentLocaleValue(SEOTemplate, 'page_title')}
              placeholder={getPlaceholderText(SEOTemplate, 'page_title')}
              onChange={(value) => handleUpdate("page_title", value)}
              error={errorsFor("page_title")}
              monospaced={true}
              helpText={isDefaultLocale ? "" : t("seoTemplates.form.defaultValue", { value: getPlaceholderText(SEOTemplate, 'page_title') })}
            />
            <TextField
              label={t("seoTemplates.form.description")}
              value={getCurrentLocaleValue(SEOTemplate, 'page_description')}
              placeholder={getPlaceholderText(SEOTemplate, 'page_description')}
              onChange={(value) => handleUpdate("page_description", value)}
              error={errorsFor("page_description")}
              monospaced={true}
              multiline={4}
              helpText={isDefaultLocale ? "" : t("seoTemplates.form.defaultValue", { value: getPlaceholderText(SEOTemplate, 'page_description') })}
            />
          </FormLayout>
        </Card.Section>
        <Card.Section title={t("seoTemplates.form.searchEnginePreview")}>
          <FormLayout>
            <TextField
              label={t("seoTemplates.form.pageTitle")}
              value={getCurrentLocaleValue(SEOTemplate, 'meta_title')}
              placeholder={getPlaceholderText(SEOTemplate, 'meta_title')}
              onChange={(value) => handleUpdate("meta_title", value)}
              error={errorsFor("meta_title")}
              monospaced={true}
              helpText={isDefaultLocale ? "" : t("seoTemplates.form.defaultValue", { value: getPlaceholderText(SEOTemplate, 'meta_title') })}
            />
            <TextField
              label={t("seoTemplates.form.metaDescription")}
              value={getCurrentLocaleValue(SEOTemplate, 'meta_description')}
              placeholder={getPlaceholderText(SEOTemplate, 'meta_description')}
              onChange={(value) => handleUpdate("meta_description", value)}
              error={errorsFor("meta_description")}
              monospaced={true}
              multiline={4}
              helpText={isDefaultLocale ? "" : t("seoTemplates.form.defaultValue", { value: getPlaceholderText(SEOTemplate, 'meta_description') })}
            />
          </FormLayout>
        </Card.Section>
      </Card>
    </Page>
  );
}
